export function setRangePanelDate(root, params) {
  var leftPanel = root.getPanel('left');
  var rightPanel = root.getPanel('right');
  var leftDate = leftPanel.getDate();
  var rightDate = rightPanel.getDate();

  if (rightDate.getMonth() - leftDate.getMonth() === 1) {
    !leftPanel.getHideNext() && leftPanel.setHideNext(true);
    !rightPanel.getHidePrev() && rightPanel.setHidePrev(true);
  } else {
    leftPanel.getHideNext() && leftPanel.setHideNext(false);
    rightPanel.getHidePrev() && rightPanel.setHidePrev(false);
  }
}